module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 2_right_Light Blue.73926e5b.svg";